class HorizontalScroll {
  constructor(options={}) {
    this.el = options.slider;
    this.parent = options.slider.parentElement;
    this.controls = this.parent.querySelectorAll('.horizontal-slider-controls .control');
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.activeClass = 'active';
    this.swipeClass = 'swipe';
    this.scrollSize = 100 / this.controls.length;

    // Bind events
    this.touchEnd = this.touchEnd.bind(this);
    this.touchStart = this.touchStart.bind(this);
    this.setSwipeEvents = this.setSwipeEvents.bind(this);

    // Trigger initial events
    this.setSwipeEvents();
    this.setControlsEvents();
    this.addEventListeners();
  }

  addEventListeners() {
    window.addEventListener('resize', this.setSwipeEvents, false);
  }

  setControlsEvents() {
    this.controls.forEach((control) => {
      const itemNumber = control.dataset.item;
      const translateSize = this.scrollSize * itemNumber;

      control.addEventListener('click', (event) => {
        this.controls.forEach((button) => button.classList.remove(this.activeClass));
        control.classList.add(this.activeClass);

        this.el.style.transform = `translateX(-${translateSize}%)`;
      });
    });
  }

  setSwipeEvents() {
    this.el.style.transform = 'translateX(0)';
    this.controls.forEach((control) => control.classList.remove(this.activeClass));
    this.controls[0].classList.add(this.activeClass);

    if (this.el.clientWidth > this.parent.clientWidth) {
      this.el.classList.add(this.swipeClass);
      this.el.addEventListener('touchstart', this.touchStart, false);
      this.el.addEventListener('touchend', this.touchEnd, false);
    } else {
      this.el.classList.remove(this.swipeClass);
      this.el.removeEventListener('touchstart', this.touchStart, false);
      this.el.removeEventListener('touchend', this.touchEnd, false);
    }
  }

  touchStart(event) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  touchEnd(event) {
    this.touchEndX = event.changedTouches[0].screenX;

    this.handleSwipe()
  }

  handleSwipe() {
    let activeControl;

    this.controls.forEach((control) => {
      if (control.classList.contains(this.activeClass)) {
        activeControl = control;
      }
    });

    if (activeControl) {
      this.triggerNextControl(activeControl);
    }
  }

  triggerNextControl(activeControl) {
    let nextControl;
    const direction = this.touchEndX < this.touchStartX ? 'left' : 'right';

    if (direction === 'left') {
      nextControl = activeControl.nextElementSibling;
    } else {
      nextControl = activeControl.previousElementSibling;
    }

    if (nextControl) {
      nextControl.click();
    }
  }
}

export function horizontalScrollInit() {
  const sliders = document.querySelectorAll('.horizontal-slider');

  sliders.forEach((slider) => {
    new HorizontalScroll({ slider });
  });
}



// WEBPACK FOOTER //
// ./src/js/horizontal-scroll.js